module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/jordy-800-fc85c5d7c1ab65dd3a015129bae2c3a1.webp";